(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const nav = document.querySelector('[data-bbx-nav]');
  const navActions = nav?.querySelector('.bbx-nav__actions');
  const menu = document.querySelector('[data-bbx-mobile-menu]');
  const toggles = document.querySelectorAll('[data-bbx-menu-toggle]');
  const closes = document.querySelectorAll('[data-bbx-menu-close]');
  const revealItems = document.querySelectorAll('[data-bbx-reveal]');
  let lastFocusedElement = null;

  if (navActions && !navActions.querySelector('[data-bbx-my-account]')) {
    const accountLink = document.createElement('a');
    accountLink.href = '/pages/blackbox-express?view=my-bbx';
    accountLink.className = 'bbx-nav__phone';
    accountLink.dataset.bbxMyAccount = '';
    accountLink.rel = 'nofollow';
    accountLink.textContent = 'My BBX';
    const phoneLink = navActions.querySelector('.bbx-nav__phone');
    if (phoneLink) phoneLink.insertAdjacentElement('afterend', accountLink);
    else navActions.prepend(accountLink);
  }

  const focusableSelector =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  const setMenuState = (open) => {
    if (!menu) return;

    if (open) {
      lastFocusedElement = document.activeElement;
      menu.hidden = false;
      window.requestAnimationFrame(() => {
        menu.setAttribute('aria-hidden', 'false');
        menu.classList.add('is-open');
        const firstFocusTarget = menu.querySelector(focusableSelector);
        if (firstFocusTarget) firstFocusTarget.focus({ preventScroll: true });
      });
    } else {
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      window.setTimeout(() => {
        menu.hidden = true;
        if (lastFocusedElement instanceof HTMLElement) lastFocusedElement.focus({ preventScroll: true });
      }, reduceMotion.matches ? 0 : 260);
    }

    toggles.forEach((toggle) => {
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Close navigation menu' : 'Open navigation menu');
    });
    document.documentElement.classList.toggle('bbx-menu-open', open);
  };

  toggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const isOpen = !menu?.hidden && menu?.getAttribute('aria-hidden') === 'false';
      setMenuState(!isOpen);
    });
  });

  closes.forEach((close) => {
    close.addEventListener('click', () => setMenuState(false));
  });

  if (menu) {
    menu.addEventListener('click', (event) => {
      if (event.target.closest('a[href]')) setMenuState(false);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && menu.getAttribute('aria-hidden') === 'false') {
        setMenuState(false);
      }
      if (event.key === 'Tab' && menu.getAttribute('aria-hidden') === 'false') {
        const focusable = Array.from(menu.querySelectorAll(focusableSelector)).filter(
          (element) => !element.hasAttribute('disabled') && element.offsetParent !== null
        );
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    });
  }

  document.querySelectorAll('a[href^="#bbx-"]').forEach((anchor) => {
    anchor.addEventListener('click', (event) => {
      const target = document.querySelector(anchor.getAttribute('href'));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({
        behavior: reduceMotion.matches ? 'auto' : 'smooth',
        block: 'start',
      });
    });
  });

  if ('IntersectionObserver' in window && !reduceMotion.matches) {
    document.documentElement.classList.add('bbx-motion-ready');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.14,
        rootMargin: '0px 0px -8% 0px',
      }
    );
    revealItems.forEach((item) => observer.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  }

  if (nav) {
    let ticking = false;
    const updateNav = () => {
      nav.classList.toggle('is-scrolled', window.scrollY > 18);
      ticking = false;
    };
    window.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(updateNav);
      },
      { passive: true }
    );
    updateNav();
  }
})();
